<template>
  <div class="mathRoad_container">
    <div :class="{
        container_bg: true,
        container_green: curBG === 'typeGreen' ? true : false,
      }">
      <img :src="getContainerBG" v-if="backgroundMask" />
      <img class="bg_container" :src="getContainerBG_" />
    </div>
    <div class="father_bar">
      <div class="factory_bar" ref="factory">

        <p style="margin:15px 0 0 5px"><span class="title_color">监测设备: </span>TSP<span class="number">{{facotryMonitorDeviceList["TSP"]}}</span>个，VDM<span
            class="number">{{facotryMonitorDeviceList["VDM"]}}</span>个</p>
        <p><span class="title_color">生产设备: </span><span class="number">{{productDeviceCount}}</span>台<span class="title_color">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;治理设备: </span><span
            class="number">{{governmentDeviceCount}}</span>台
        </p>
        <p><span class="title_color">排放源点: </span><span class="number">{{emissionSourceCount}}</span>个
        </p>
        <p style="margin-top:10px;">
          <span class="title_color">当日闭环事件管理: </span>
        </p>
        <div class="treatment_bar">
          发生<span style="color:#63BD93;" class="number">{{workTicketCount}}</span>项， 执行<span style="color:#63BD93;" class="number">{{treatmentCount}}</span>项，<span
            v-if="treatmentRate||treatmentRate!='-'">执行率:
            {{treatmentRate}}</span>
        </div>

        <!--p><span class="title_color">监测设备: </span>TSP<span class="number">{{facotryMonitorDeviceList["TSP"]}}</span>个， VDM<span class="number">{{facotryMonitorDeviceList["VDM"]}}</span>个</p>
        <p><span class="title_color">生产设备: </span><span class="number">{{productDeviceCount}}</span>台 <span class="title_color">治理设备: </span><span class="number">{{governmentDeviceCount}}</span>台</p>
        <p style="color:#63BD93;"><span class="title_color">当月闭环管理事件: </span>发生<span style="color:#63BD93;" class="number">{{workTicketCount}}</span>项， <span v-if="workTicketCount!=0">执行率:
            {{treatmentRate}}</span></p-->
      </div>
      <div class="alarm_bar" ref="alarm">
        <div class="alarm_inner">
          <!--p style="text-align:center; font-size:28px; margin-top: -10px"><span class="emission_bar number">{{emissionSourceCount}}</span>排放源点(个)</p-->
          <p class="factory_title">{{branchFactory}}</p>
          <p class="treatment_rate"></p>
          <p>
            <span class="title_color">配套生产工艺设备: </span>
            <span class="description">{{description}}</span>
          </p>
        </div>
      </div>
      <div class="factorySub_bar" ref="factorySub">
        <warn ref="resultWarn" v-if="resultWarnTypeId && resultWarnObj" :data="resultWarnObj" :typeId="resultWarnTypeId"></warn>
        <!--p style="color:#63BD93;"><span class="title_color">当月闭环管理事件: </span>发生<span style="color:#63BD93;" class="number">{{workTicketCount}}</span>项， <span v-if="workTicketCount!=0">执行率:
            {{treatmentRate}}</span></p-->
      </div>
      <!--div class="factory_bar_shadow yy"></div-->
      <warn ref="warn" v-if="typeId && warnObj" :data="warnObj" :typeId="typeId"></warn>
    </div>
    <div class="overal_bg" v-if="curBG == 'typeDark'"></div>
    <div class="overal_bg_strong" v-if="curBG == 'typeStrong'"></div>
  </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import {
  ExitCruiseFunc,
  CamFixFunc,
  LoadLabelFunc,
  DestroyLabelFunc,
  ParseRoamFunc,
  ContinueRoamFunc,
  CruiseLeapFunc,
  CruiseLeapBackFunc,
  ShowWallDataFunc,
  CloseWallFunc,
  HideHeatLineFunc,
  ChangeFlySpeedFunc,
  OpenPointsMeshFunc,
  ClosePointsMeshFunc,
} from "@/assets/js/unity3D/index.js";

import warn from "@/modules/AutoVisionMod/warn.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { warn },
  props: {},
  data() {
    //这里存放数据
    return {
      backgroundMask: bmeConfig.backgroundMask,
      customerId: this.$store.state.customerId,
      bme3dManagerLoaded: false,
      isSetting: false,
      hash: false,
      modelType: "AutoVision",
      styleType: bmeConfig.styleType,
      styleTypeMap: styleTypeMap,
      curBG: "",
      refreshTag: true,
      eventData: {},
      curMapType: "",

      factoryDetailShow: false,
      warnDetailShow: false,

      branchFactory: "",
      emissionSourceCount: 0,
      productDeviceCount: 0,
      governmentDeviceCount: 0,
      facotryMonitorDeviceList: {},
      workTicketCount: 0,
      treatmentCount: 0,
      treatmentRate: "0.00%",

      typeId: "",
      warnObj: "",

      playTimer: null,

      factoryTimer: null,

      warnList: [],

      factoryPos: 0,

      factoryReplayTimer: null,

      flyPointStatus: false,

      resultScroll: "",

      description: "",

      hasNext: false,

      resultWarnObj: {},

      resultWarnTypeId: "",

      mircoList: [],

      mircoRepeatCheck: [],

      mircoTimer: null,
    };
  },
  computed: {
    getContainerBG: function () {
      let imgSrc = "";
      if (
        this.curBG &&
        this.styleTypeMap[this.curBG] &&
        this.styleTypeMap[this.curBG].dutyBG
      ) {
        imgSrc = require("@/views/MainMod/img/" +
          this.styleTypeMap[this.curBG].dutyBG);
      }
      if (!bmeConfig.backgroundMask) {
        imgSrc = "";
      }
      return imgSrc;
    },
    getContainerBG_: function () {
      let imgSrc = "";
      if (
        this.curBG &&
        this.styleTypeMap[this.curBG] &&
        this.styleTypeMap[this.curBG].dutyBG
      ) {
        imgSrc = require("@/views/AutoVisionMod/img/bg.png");
      }
      return imgSrc;
    },
    curBGVal: function () {
      return this.$store.state.curBG;
    },
    mapTypeVal() {
      return this.$store.state.mapType;
    },
  },
  //监控data中的数据变化
  watch: {
    hash: {
      handler(newVal, oldVal) {
        this.isSetting = newVal;
      },
      deep: true,
    },
    curBGVal: {
      handler(newVal, oldVal) {
        this.curBG = newVal;
      },
      deep: true,
    },
    mapTypeVal: {
      handler(newVal, oldVal) {
        this.curMapType = newVal;
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    async getVdmData() {
      let that = this;
      let getMonitorUrl = CONFIG.requestName + that.$apiOpt.monitor;
      let result = await that.$apiUtils.get(getMonitorUrl, {
        customerId: that.$store.state.customerId,
        gas: "VDM",
      });
      window.overalVdmData = new Object();
      result.forEach((item) => {
        window.overalVdmData[item.SN] = item;
      });
      return result;
    },
    async getPM10Data() {
      let that = this;
      let getMonitorUrl = CONFIG.requestName + that.$apiOpt.monitor;
      let result = await that.$apiUtils.get(getMonitorUrl, {
        customerId: that.$store.state.customerId,
        gas: "PM10",
      });
      window.overalPM10Data = new Object();
      result.forEach((item) => {
        window.overalPM10Data[item.SN] = item;
      });
      return result;
    },
    async getTspData() {
      let that = this;
      let getMonitorUrl = CONFIG.requestName + that.$apiOpt.monitor;
      let result = await that.$apiUtils.get(getMonitorUrl, {
        customerId: that.$store.state.customerId,
        gas: "TSP",
      });
      window.overalDustData = new Object();
      result.forEach((item) => {
        window.overalDustData[item.SN] = item;
      });
      return result;
    },
    async roadVisionFunc(factoryList, isRe) {
      if (!isRe) {
        clearTimeout(this.factoryReplayTimer);
        CloseWallFunc();
      }
      let that = this;
      console.log("=====================");
      console.log(factoryList);
      if (factoryList.length == 0) {
        return;
      }

      if (this.factoryDetailShow) {
        this.factoryReplayTimer = setTimeout(() => {
          this.roadVisionFunc(factoryList, true);
          this.hasNext = true;
        }, 5000);
        return;
      }
      this.hasNext = false;

      if (this.factoryTimer) {
        clearTimeout(this.factoryTimer);
      }

      $(this.$refs.factory).removeClass("left");
      $(this.$refs.factory).removeClass("right");
      $(this.$refs.factorySub).removeClass("factorySubLeft");
      $(this.$refs.factorySub).removeClass("factorySubRight");

      $(this.$refs.alarm).removeClass("leftAlarm");
      $(this.$refs.alarm).removeClass("rightAlarm");
      if (factoryList[0]["location"] === 0) {
        $(this.$refs.factory).addClass("left");
        $(this.$refs.factorySub).addClass("factorySubRight");
        $(this.$refs.alarm).addClass("leftAlarm");
        this.factoryPos = 0;
      } else if (factoryList[0]["location"] === 1) {
        $(this.$refs.factory).addClass("right");
        $(this.$refs.factorySub).addClass("factorySubLeft");
        $(this.$refs.alarm).addClass("rightAlarm");
        this.factoryPos = 1;
      }

      if (this.warnDetailShow && this.$refs.warn) {
        $(this.$refs.warn.$el).removeClass("warnLeft");
        $(this.$refs.warn.$el).removeClass("warnRight");
        if (this.factoryPos === 0) {
          $(this.$refs.warn.$el).addClass("warnRight");
        } else if (this.factoryPos === 1) {
          $(this.$refs.warn.$el).addClass("warnLeft");
        }
      }

      let ShowWallObj = [{ WallID: factoryList[0]["id"] }];
      //ShowWallDataFunc(JSON.stringify(ShowWallObj));

      let factoryProfileUrl = CONFIG.requestName + that.$apiOpt.factoryProfile;
      let result = await that.$apiUtils.get(factoryProfileUrl, {
        customerId: that.$store.state.customerId,
        id: factoryList[0]["id"],
      });

      let findDeviceListUrl =
        CONFIG.requestName + that.$apiOpt.findDeviceListAutoVision;
      let resultDetail = await that.$apiUtils.get(findDeviceListUrl, {
        id: factoryList[0]["id"],
      });

      console.log(result);
      console.log(resultDetail);

      let equipList = [];
      for (let i in resultDetail) {
        resultDetail[i].forEach((item) => {
          if ($.inArray(item.deviceNo, equipList) < 0) {
            equipList.push(item.deviceNo);
          }
        });
      }
      this.resultScroll = "";
      let scrollByTimeUrl = CONFIG.requestName + that.$apiOpt.scrollByTime;
      let resultScroll = await that.$apiUtils.get(scrollByTimeUrl, {
        customerId: that.$store.state.customerId,
        deviceNoList: equipList.join(","),
      });
      this.resultScroll = resultScroll;
      console.log("resultScroll:" + resultScroll);

      let getWorkTicketUrl = CONFIG.requestName + this.$apiOpt.scrollThreeMap;
      let resultWarn = await that.$apiUtils.get(getWorkTicketUrl, {
        customerId: that.$store.state.customerId,
        deviceNoList: equipList.join(","),
      });
      console.log(resultWarn);
      if (resultWarn.length > 0) {
        this.resultWarnObj = resultWarn[resultWarn.length - 1];
        this.resultWarnTypeId = resultWarn[resultWarn.length - 1].typeId;

        this.$forceUpdate();
        this.$nextTick(() => {
          if (this.$refs.resultWarn) {
            $(this.$refs.resultWarn.$el).fadeIn(1000);
          }
        });
      }

      this.branchFactory = result.branchFactory;
      this.emissionSourceCount = result.emissionSourceCount
        ? result.emissionSourceCount
        : 0;
      this.productDeviceCount = result.productDeviceCount
        ? result.productDeviceCount
        : 0;
      this.governmentDeviceCount = result.governmentDeviceCount
        ? result.governmentDeviceCount
        : 0;
      this.facotryMonitorDeviceList = { TSP: 0, VDM: 0 };
      if (
        result.facotryMonitorDeviceList &&
        result.facotryMonitorDeviceList.length > 0
      ) {
        result.facotryMonitorDeviceList.forEach((item) => {
          if (item.typeName && item.typeName.indexOf("TSP") >= 0) {
            this.facotryMonitorDeviceList["TSP"] += item.deviceCount;
          } else if (item.typeName && item.typeName.indexOf("VDM") >= 0) {
            this.facotryMonitorDeviceList["VDM"] += item.deviceCount;
          }
        });
      } else {
        this.facotryMonitorDeviceList["TSP"] = 0;
        this.facotryMonitorDeviceList["VDM"] = 0;
      }

      //this.facotryMonitorDeviceList = result.facotryMonitorDeviceList;
      this.workTicketCount = result.workTicketCount
        ? result.workTicketCount
        : "0";
      this.treatmentCount = result.treatmentCount ? result.treatmentCount : "0";
      this.treatmentRate = result.treatmentRate
        ? result.treatmentRate
        : "0:00%";
      this.description = result.description;

      clearTimeout(this.playTimer);
      if (this.$refs.warn) {
        $(this.$refs.warn.$el).fadeOut(50, () => {
          this.warnDetailShow = false;
        });
      }

      this.factoryDetailShow = true;
      $(this.$refs.factory).stop(true, true);
      $(this.$refs.factorySub).stop(true, true);
      $(this.$refs.alarm).stop(true, true);

      $(this.$refs.factory).hide();
      $(this.$refs.factorySub).hide();
      $(this.$refs.alarm).hide();
      this.$forceUpdate();

      $(this.$refs.factory).fadeIn(1000);
      $(this.$refs.alarm).fadeIn(2000);
      $(this.$refs.factorySub).fadeIn(1000);

      if (ChangeFlySpeedFunc) {
        ChangeFlySpeedFunc("4");
      }

      if (this.$refs.factory) {
        if (this.factoryTimer) {
          clearTimeout(this.factoryTimer);
        }
        this.factoryTimer = setTimeout(
          () => {
            $(this.$refs.alarm).fadeOut(1000);
            $(this.$refs.factorySub).fadeOut(1000);
            $(this.$refs.factory).fadeOut(1000, () => {
              this.factoryDetailShow = false;
              if (ChangeFlySpeedFunc) {
                ChangeFlySpeedFunc("8");
              }
              //CloseWallFunc();
            });
          },
          this.hasNext ? 10000 : 18000
        );
      }
    },
    roadVisionEquipFunc(equipList) {
      let that = this;

      /*if (!equipList || equipList.length === 0) {
        return;
      }*/

      /*if (this.playTimer) {
        clearTimeout(this.playTimer);
      }
      if (this.$refs.warn) {
        $(this.$refs.warn.$el).fadeOut(2000, () => {
          this.warnDetailShow = false;
        });
      }*/

      //console.log("333", result);
      if (!this.factoryDetailShow && !this.warnDetailShow) {
        let equip = this.mircoList.pop();
        if (equip) {
          this.warnList = [equip];
          if (this.warnList.length > 0) {
            this.playWarn();
          }
        }
      }
    },
    roadPushStack(list) {
      list.forEach((item) => {
        if (
          $.inArray(item, this.mircoRepeatCheck) < 0 &&
          $.inArray(item, this.mircoList) < 0
        ) {
          this.mircoList.push(item);
          this.mircoRepeatCheck.push(item);
        }
      });
      console.log("mircoList:" + this.mircoList);
    },
    enterNextRoadFunc() {
      /*if (this.$refs.factory) {
        $(this.$refs.factory).fadeOut(2000, () => {
          this.factoryDetailShow = false;
        });
      }

      this.warnList = [];
      if (this.playTimer) {
        clearTimeout(this.playTimer);
      }
      if (this.$refs.warn) {
        $(this.$refs.warn.$el).fadeOut(2000, () => {
          this.warnDetailShow = false;
        });
      }*/
    },
    renderSingleBubble(latitude, longitude, SN, val, type) {
      DestroyLabelFunc();
      let seriseId = "1";
      if (type === "cems") {
        seriseId = "3";
      } else if (type === "tsp") {
        poisType = "2";
      } else if (type === "vdm") {
        poisType = "2";
      } else if (type === "pm") {
        poisType = "1";
      }
      let poisType = "PM10";
      if (type === "cems") {
        poisType = "CEMS";
      } else if (type === "tsp") {
        poisType = "TSP";
      } else if (type === "vdm") {
        poisType = "VDM";
      } else if (type === "pm") {
        poisType = "PM10";
      }
      var pm10Obj = {
        dataList: [],
        seriseId: seriseId,
        poisType: poisType,
        callBackFunc: "poisClick",
        aggregated: "false",
      };
      if (latitude && longitude) {
        let tmpColor = 0;
        if (val < 100) {
          tmpColor = 30;
        } else if (val < 200) {
          tmpColor = 60;
        } else {
          tmpColor = 100;
        }
        pm10Obj.dataList.push({
          lat: latitude,
          lng: longitude,
          id: SN,
          value: val,
          color: tmpColor,
        });
      }
      window.bubbleJson = JSON.stringify(pm10Obj);
      LoadLabelFunc(window.bubbleJson);
    },
    async playWarn() {
      let that = this;
      this.warnDetailShow = true;
      if (this.warnList && this.warnList.length > 0) {
        console.log(this.warnList);
        let equipId = this.warnList.shift();
        let getWorkTicketUrl = CONFIG.requestName + this.$apiOpt.scrollThreeMap;
        let tmpList = await that.$apiUtils.get(getWorkTicketUrl, {
          customerId: that.$store.state.customerId,
          deviceNoList: equipId,
        });
        if (tmpList.length > 0 && !this.factoryDetailShow) {
          this.warnObj = tmpList[0];
          this.typeId = tmpList[0].typeId;

          this.$forceUpdate();
          this.$nextTick(() => {
            if (this.$refs.warn) {
              let lng = this.warnObj.longitude;
              let lat = this.warnObj.latitude;
              let SN = this.warnObj.deviceNo;
              let val = this.warnObj.value;
              /*if (lng && lat) {
                this.renderSingleBubble(lat, lng, SN, val);
                if (ParseRoamFunc) {
                  this.flyPointStatus = true;
                  ParseRoamFunc();
                }
                this.parseRoamTimer = setTimeout(() => {
                  if (CruiseLeapFunc) {
                    CruiseLeapFunc(lng, lat);
                  }

                  this.cruiseLeapTimer = setTimeout(() => {
                    CruiseLeapBackFunc();
                    this.contiueRoamTimer = setTimeout(() => {
                      ContinueRoamFunc();
                      this.flyPointStatus = false;
                      DestroyLabelFunc();
                    }, 3000);
                  }, 8000);
                }, 2000);
              }*/
              if (ChangeFlySpeedFunc) {
                ChangeFlySpeedFunc("4");
              }
              $(this.$refs.warn.$el).fadeIn(1000, function () {
                this.warnDetailShow = true;
              });
              $(this.$refs.warn.$el).removeClass("warnLeft");
              $(this.$refs.warn.$el).removeClass("warnRight");
              if (this.factoryPos === 0) {
                $(this.$refs.warn.$el).addClass("warnRight");
              } else if (this.factoryPos === 1) {
                $(this.$refs.warn.$el).addClass("warnLeft");
              }
            }
          });

          this.playTimer = setTimeout(() => {
            if (this.$refs.warn) {
              $(this.$refs.warn.$el).fadeOut(2000, () => {
                this.warnDetailShow = false;
                if (ChangeFlySpeedFunc) {
                  ChangeFlySpeedFunc("8");
                }
              });
            }
            //this.playWarn();
          }, 8000);
        } /*else {
          let getDeviceLocationUrl =
            CONFIG.requestName + this.$apiOpt.getDeviceLocation;
          let deviceResult = await that.$apiUtils.get(getDeviceLocationUrl, {
            customerId: that.$store.state.customerId,
            deviceNo: equipId,
          });
          console.log(deviceResult);
          let tmpObj = window.PointInfo[equipId];
          let tmpType = tmpObj["type"];
          if (tmpType === "cems") {
            let lng = deviceResult.longitude;
            let lat = deviceResult.latitude;
            let SN = equipId;
            let val = "";
            if (lng && lat) {
              this.renderSingleBubble(lat, lng, SN, val, "cems");
              if (ParseRoamFunc) {
                this.flyPointStatus = true;
                ParseRoamFunc();
              }
              this.parseRoamTimer = setTimeout(() => {
                if (CruiseLeapFunc) {
                  CruiseLeapFunc(lng, lat);
                }

                this.microTimer = setTimeout(() => {
                  this.$cemsPopup.cb(SN);
                }, 3000);

                this.cruiseLeapTimer = setTimeout(() => {
                  CruiseLeapBackFunc();
                  this.contiueRoamTimer = setTimeout(() => {
                    this.$cemsClose.cb();
                    ContinueRoamFunc();
                    this.flyPointStatus = false;
                    DestroyLabelFunc();
                  }, 3000);
                }, 8000);
              }, 2000);
            }
          } else if (tmpType === "tsp") {
            let lng = deviceResult.longitude;
            let lat = deviceResult.latitude;
            let SN = equipId;
            let val = deviceResult.realValue;
            if (lng && lat) {
              this.renderSingleBubble(lat, lng, SN, val, "tsp");
              if (ParseRoamFunc) {
                this.flyPointStatus = true;
                ParseRoamFunc();
              }
              this.parseRoamTimer = setTimeout(() => {
                if (CruiseLeapFunc) {
                  CruiseLeapFunc(lng, lat);
                }

                this.microTimer = setTimeout(() => {
                  this.$tspPopup.cb(SN);
                }, 3000);

                this.cruiseLeapTimer = setTimeout(() => {
                  CruiseLeapBackFunc();
                  this.contiueRoamTimer = setTimeout(() => {
                    this.$tspClose.cb();
                    ContinueRoamFunc();
                    this.flyPointStatus = false;
                    DestroyLabelFunc();
                  }, 3000);
                }, 8000);
              }, 2000);
            }
          } else if (tmpType === "vdm") {
            let lng = deviceResult.longitude;
            let lat = deviceResult.latitude;
            let SN = equipId;
            let val = deviceResult.realValue;
            if (lng && lat) {
              this.renderSingleBubble(lat, lng, SN, val, "vdm");
              if (ParseRoamFunc) {
                this.flyPointStatus = true;
                ParseRoamFunc();
              }
              this.parseRoamTimer = setTimeout(() => {
                if (CruiseLeapFunc) {
                  CruiseLeapFunc(lng, lat);
                }

                this.microTimer = setTimeout(() => {
                  this.$vdmPopup.cb(SN);
                }, 3000);

                this.cruiseLeapTimer = setTimeout(() => {
                  CruiseLeapBackFunc();
                  this.contiueRoamTimer = setTimeout(() => {
                    this.$vdmClose.cb();
                    ContinueRoamFunc();
                    this.flyPointStatus = false;
                    DestroyLabelFunc();
                  }, 3000);
                }, 8000);
              }, 2000);
            }
          } else if (tmpType && tmpType.indexOf("pm") >= 0) {
            let lng = deviceResult.longitude;
            let lat = deviceResult.latitude;
            let SN = equipId;
            let val = deviceResult.realValue;
            if (lng && lat) {
              this.renderSingleBubble(lat, lng, SN, val, "pm10");
              if (ParseRoamFunc) {
                this.flyPointStatus = true;
                ParseRoamFunc();
              }
              this.parseRoamTimer = setTimeout(() => {
                if (CruiseLeapFunc) {
                  CruiseLeapFunc(lng, lat);
                }

                this.microTimer = setTimeout(() => {
                  this.$pm10Popup.cb(SN);
                }, 3000);

                this.cruiseLeapTimer = setTimeout(() => {
                  CruiseLeapBackFunc();
                  this.contiueRoamTimer = setTimeout(() => {
                    this.$pm10Close.cb();
                    ContinueRoamFunc();
                    this.flyPointStatus = false;
                    DestroyLabelFunc();
                  }, 3000);
                }, 8000);
              }, 2000);
            }
          }
        }*/
      } else {
        if (this.playTimer) {
          clearTimeout(this.playTimer);
        }
        if (this.$refs.warn) {
          $(this.$refs.warn.$el).fadeOut(2000, () => {
            this.warnDetailShow = false;
            if (ChangeFlySpeedFunc) {
              ChangeFlySpeedFunc("8");
            }
          });
        }
      }
    },
    endPathFunc() {
      this.mircoRepeatCheck = [];
      this.mircoList = [];
      window.roadMeetList = [];
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query && this.$route.query.setting == "true") {
      this.hash = true;
    } else {
      this.hash = false;
    }
    this.curMapType = this.$store.state.mapType;
  },
  beforeUnmount() {
    if (this.mircoTimer) {
      clearInterval(this.mircoTimer);
    }
    this.endPathFunc();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.curBG = this.$store.state.curBG;

    this.$roadVisionFunc.cb = this.roadVisionFunc;
    this.$roadVisionEquipFunc.cb = this.roadPushStack;
    this.$endPathFunc.cb = this.endPathFunc;

    this.$enterNextRoadFunc.cb = this.enterNextRoadFunc;

    this.getTspData();

    this.getVdmData();

    this.getPM10Data();

    if (closePointsMeshFunc) {
      closePointsMeshFunc();
    }

    this.mircoTimer = setInterval(() => {
      this.roadVisionEquipFunc();
    }, 1000);
    /*this.roadVisionEquipFunc();
    this.factoryDetailShow = true;
    this.warnDetailShow = true;
    $(this.$refs.factory).fadeOut(50);
    $(this.$refs.factory).fadeIn(5000);
*/
    //this.factoryDetailShow = true;

    if (HideHeatLineFunc) {
      setTimeout(() => {
        HideHeatLineFunc();
      }, 500);
    }

    $(this.$refs.factory).hide();
    $(this.$refs.factorySub).hide();
    $(this.$refs.alarm).hide();
    //this.roadVisionFunc([{ id: "1", location: 1 }]);
    if (ChangeFlySpeedFunc) {
      ChangeFlySpeedFunc("8");
    }
  },
  activated() {},
  deactivated() {},
  beforeRouteLeave() {
    if (this.parseRoamTimer) {
      clearTimeout(this.parseRoamTimer);
    }
    if (this.microTimer) {
      clearTimeout(this.microTimer);
    }
    if (this.cruiseLeapTimer) {
      clearTimeout(this.cruiseLeapTimer);
    }
    if (this.contiueRoamTimer) {
      clearTimeout(this.contiueRoamTimer);
    }
    if (ExitCruiseFunc) {
      ExitCruiseFunc();
      //window.autoVison = false;
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.setting == "true") {
      this.hash = true;
    } else {
      this.hash = false;
    }
    this.reload();
  },
};
</script>
<style scoped>
.mathRoad_container {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
}

.father_bar {
  -webkit-perspective: 1000px;
  -moz-perspective: 1000px;
  perspective: 1000px;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.bg_container {
  position: absolute;
  width: 94% !important;
  margin: 0 3% !important;
  height: 80% !important;
  margin-top: 3% !important;
}

.factory_bar {
  position: absolute;
  /*background: linear-gradient(271deg, rgb(0 0 0 / 50%), rgb(1 19 45 / 50%));*/
  /*background-image: url("/static/img/factoryBar.png");*/
  background-image: url("img/factoryMain.png");
  background-size: 100% 100%;
  transform: translate3d(100px, 100px, 100px);
  width: 650px;
  height: 550px;
  font-weight: bolder;
  padding: 90px 70px 8px 80px;
  font-size: 24px;
  font-family: "fontNormal";
}

.factorySub_bar {
  position: absolute;
  /*background: linear-gradient(271deg, rgb(0 0 0 / 50%), rgb(1 19 45 / 50%));*/
  /*background-image: url("/static/img/factoryBar.png");*/
  background-size: 100% 100%;
  transform: translate3d(100px, 100px, 100px);
  width: 650px;
  height: 550px;
  font-weight: bolder;
  padding: 80px 70px 8px 80px;
  font-size: 24px;
  font-family: "fontNormal";
}

.factorySubLeft {
  left: 800px;
  top: 0px;
}

.factorySubRight {
  right: 800px;
  top: 0px;
}

.alarm_bar {
  position: absolute;
  transform: translate3d(100px, 100px, 100px);
  width: 600px;
  font-family: "fontNormal";
  border-radius: 10px;
  /*background-image: url("img/warnBg.png");*/
  background-image: url("img/factorySub_.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  padding: 0px;
}

.alarm_inner {
  font-size: 30px;
  width: 600px;
  padding: 40px 60px;
  position: relative;
  font-family: "fontNormal";
  margin-top: 55px;
}

.alarm_inner > p {
  padding: 5px 0;
}

.emission_bar {
  color: #57eaf8 !important;
  font-size: 50px !important;
  text-align: center;
  margin: 30px 0 0 -90px;
}

.emission_title {
  color: #cccccc !important;
  font-size: 20px !important;
  text-align: center;
  margin: 0px 0px 0px -90px;
}

.leftAlarm {
  left: 1360px;
  height: 380px;
  top: 350px;
  transform: translate3d(0px, 0px, 90px) rotateY(30deg) rotateX(-3deg);
}

.rightAlarm {
  right: 1360px;
  height: 380px;
  top: 350px;
  transform: translate3d(0px, 0px, 90px) rotateY(-30deg) rotateX(-3deg);
}

.left {
  /*transform: translate3d(800px, 260px, 90px) rotate3d(0, 1, 0, 85deg);*/
  transform: translate3d(800px, 0px, 90px) rotateY(85deg) rotateX(-2deg);
  left: 0px;
  top: 260px;
}

.right {
  /*transform: translate3d(800px, 260px, 90px) rotate3d(0, 1, 0, -15deg);*/
  transform: translate3d(-800px, 0px, 90px) rotateY(-85deg) rotateX(-2deg);
  right: 0px;
  top: 260px;
}

.warnLeft {
  transform: translate3d(800px, 200px, 0px) rotate3d(0, 1, 0, 0deg);
  top: 0px;
  left: 0px;
}

.warnRight {
  transform: translate3d(-800px, 200px, 0px) rotate3d(0, 1, 0, 0deg);
  top: 0px;
  right: 0px;
}

.number {
  font-family: "number";
  padding: 0 10px;
  font-weight: bolder;
  color: #eee;
  font-size: 33px;
}

.description {
  position: relative;
  margin: 2px 0;
  color: #eee;
  font-size: 22px;
  display: block;
}

.factory_bar p,
.factorySub_bar p {
  color: #eee;
  padding: 7px;
}

.title_color {
  color: #c5b6a2;
  margin: -15px 0 5px 0;
  position: relative;
}

.treatment_bar {
  color: #63bd93;
  background: rgba(0, 0, 0, 0.6);
  width: 90%;
  border-radius: 5px;
  padding: 23px;
  box-shadow: 1px 1px 10px rgb(255 255 255 / 60%);
}

.factory_title {
  font-weight: bolder;
  left: 80px;
  font-size: 35px;
  margin-top: -58px;
  position: absolute;
}

.factorySub_title {
  font-weight: bolder;
  left: 60px;
  right: 80px;
  text-align: center;
  font-size: 45px;
  margin-top: -100px;
  position: absolute;
}

.treatment_rate {
  font-weight: bolder;
  right: 120px;
  font-size: 42px;
  color: #eee !important;
  margin-top: -85px;
  position: absolute;
}

.factory_bar_shadow {
  background: -webkit-linear-gradient(
        top,
        rgb(0, 0, 0) 50%,
        rgba(255, 255, 255, 0)
      )
      center center / 100% 100%,
    url("img/panelView_blueBg_3_3.png");
}

.yy {
  position: absolute;
  left: 0;
  top: 350px;
  width: 200px;
  height: 300px;
  transform: scale(1, -1);
  opacity: 0.3;
  border-radius: 5px;
}

.container_bg {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  z-index: -1;
}

.container_bg > img {
  filter: opacity(100%) grayscale(15%) blur(1px) contrast(95%) saturate(95%);
  width: 102%;
  height: 100%;
  position: absolute;
}

.container_green {
  filter: opacity(70%) grayscale(15%) blur(1px) contrast(95%) saturate(95%) !important;
}

.overal_bg {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url("/static/images/common/overal.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  z-index: -1;
}
.overal_bg_strong {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url("/static/images/common/overal.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  z-index: -1;
}

.changeSet {
  display: block;
  height: 100px;
  width: 100px;
  background: black;
  position: absolute;
  top: 0px;
  left: 0px;
  pointer-events: all;
}
</style>